import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
// Constants
import ACTION_TYPES from './useFetchData.actionTypes';

var setError = function setError(dispatch) {
  return dispatch({
    type: ACTION_TYPES.SET_ERROR
  });
};

var initializeFetching = function initializeFetching(dispatch, params) {
  return dispatch({
    type: ACTION_TYPES.INITIALIZE_FETCHING,
    payload: {
      params: params
    }
  });
};

var setData = function setData(dispatch, data) {
  return dispatch({
    type: ACTION_TYPES.SET_DATA,
    payload: {
      data: data
    }
  });
};
/**
 * Fetches and saves Data.
 * Handles Error.
 * Cancels saving if another request is made.
 * @param {Promise} fetchData promise which returns data
 * @param {Array} params parameters to be passed to fetchData promise
 * @param {Function} dispatch function to update state
 */


export function fetchDataEffect(dispatch, fetchData, params) {
  var isLastestRequest = true;
  initializeFetching(dispatch, params);
  fetchData.apply(void 0, _toConsumableArray(params)).then(function (data) {
    if (isLastestRequest) {
      setData(dispatch, data);
    }
  })["catch"](function () {
    if (isLastestRequest) {
      setError(dispatch);
    }
  });
  return function () {
    isLastestRequest = false;
  };
}